import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   listTripApiCall,
   singleTripApiCall,
   updateTripDetailsApiCall,
   updateTripManagerApiCall,
   updateTripReviewStatusApiCall,
} from "../../Api/api";

const initialState = {
   allTrips: [],
   listPagination: null,
   singleTrip: null,
   isLoading: false,
   isError: false,
   isSuccess: false,
};

// Fetch All trip list
export const listTripAsync = createAsyncThunk(
   "trip/listTrip",
   async ({ role, id, limit, offset, done, err }, thunkAPI) => {
      try {
         const { data: response } = await listTripApiCall(role, id, limit, offset);
         console.log({ response });
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue({
               data: response.data,
               pagination: response?.pagination,
            });
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Fetch single trip
export const singleTripAsync = createAsyncThunk(
   "trip/singleTrip",
   async ({ id, done, err }, thunkAPI) => {
      try {
         const { data: response } = await singleTripApiCall(id);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data.trip);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Update trip manager
export const updateTripManagerAsync = createAsyncThunk(
   "trip/updateTrip",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await updateTripManagerApiCall(data);
         if (response.statusCode === 200) {
            done && done();
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Update trip manager
export const updateTripDetailsAsync = createAsyncThunk(
   "trip/updateTrip",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await updateTripDetailsApiCall(data);
         if (response.statusCode === 200) {
            done && done();
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Update trip review status
export const updateTripReviewStatusAsync = createAsyncThunk(
   "trip/update-review-status",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await updateTripReviewStatusApiCall(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);

         return thunkAPI.rejectWithValue(error);
      }
   }
);

const tripSlice = createSlice({
   name: "trip",
   initialState: initialState,

   reducers: {
      clearTrip: (state, action) => {
         state.isLoading = false;
         state.isError = false;
         state.isSuccess = false;
      },
   },
   extraReducers: (builder) => {
      builder
         .addCase(listTripAsync.pending, (state, action) => {
            state.isLoading = true;
         })
         .addCase(listTripAsync.fulfilled, (state, action) => {
            state.allTrips = action.payload?.data;
            state.listPagination = action.payload?.pagination;
            state.isLoading = false;
         })
         .addCase(listTripAsync.rejected, (state, action) => {
            state.isError = true;
            state.isLoading = false;
         })
         .addCase(singleTripAsync.pending, (state, action) => {
            state.isLoading = true;
            state.singleTrip = null;
         })
         .addCase(singleTripAsync.fulfilled, (state, action) => {
            state.singleTrip = action.payload;
            state.isLoading = false;
         })
         .addCase(singleTripAsync.rejected, (state, action) => {
            state.isError = true;
            state.isLoading = false;
         });
   },
});

export const { clearTrip } = tripSlice.actions;

const tripReducer = tripSlice.reducer;
export default tripReducer;
